import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoints, spacing } from '@naf/theme';

export const StyledArticleBlockContentGridCol = styled.div<{ $orientation: 'left' | 'right'; $vehicleCount: number }>`
  ${({ $vehicleCount, $orientation }) => {
    if ($vehicleCount === 1 && $orientation === 'left') {
      return css`
        grid-column: 1 / -3;
      `;
    }
    if ($vehicleCount === 1 && $orientation === 'right') {
      return css`
        grid-column: 3 / -1;
      `;
    }
    if ($vehicleCount >= 3) {
      return css`
        grid-column: 1 / -1;
      `;
    }
    return css`
      grid-column: 3 / -3;
    `;
  }};

  @media (max-width: ${breakpoints.m}) {
    grid-column: 1 / -1;
  }
`;

export const Container = styled.div<{ $orientation?: 'left' | 'right'; $vehicleCount?: number }>`
  display: flex;
  gap: ${spacing.space16};
  scroll-behavior: smooth;
  justify-content: center;
  padding: ${spacing.space8};

  > a,
  p {
    height: auto;
    flex-basis: 0;
    flex-grow: 1;
    min-width: 352px;
  }

  > a {
    max-width: 352px;
  }

  div > h2 {
    margin-bottom: ${spacing.space16};
  }

  ${({ $orientation, $vehicleCount }) =>
    $orientation &&
    $vehicleCount === 1 &&
    css`
      flex-flow: ${$orientation === 'left' ? 'row-reverse wrap-reverse' : 'row wrap'};
    `};

  ${({ $vehicleCount }) =>
    $vehicleCount === 3 &&
    css`
      overflow-x: auto;
      justify-content: start;
    `}

  ${({ $vehicleCount }) =>
    $vehicleCount > 3 &&
    css`
      overflow-x: hidden;
      justify-content: start;
      cursor: grab;

      > a {
        cursor: pointer;
      }

      &.is-dragging {
        cursor: grabbing;
        user-select: none;
        scroll-behavior: auto;
      }

      &.is-dragging * {
        cursor: grabbing;
        user-select: none;
      }
    `};

  @media (max-width: ${breakpoints.l}) {
    ${({ $vehicleCount }) =>
      $vehicleCount > 3 &&
      css`
        overflow-x: scroll;
      `};
  }

  @media (max-width: ${breakpoints.m}) {
    width: calc(100vw - ${spacing.space48});
    gap: ${spacing.space16};
    justify-content: start;
    overflow-x: scroll;

    > a,
    p {
      min-width: calc(100vw - ${spacing.space48});
    }

    ${({ $vehicleCount }) =>
      $vehicleCount === 1
        ? css`
            flex-wrap: wrap;
          `
        : css`
            width: calc(100vw - ${spacing.space24});
            margin-left: -${spacing.space24};
            padding: 0 ${spacing.space24};

            > a:last-child {
              margin-right: ${spacing.space24};
            }
          `};
  }
`;

export const Header = styled.h3`
  font-size: 1.375rem;
`;

export const ScrollWrapper = styled.div``;
